import { call, put, take, takeLatest } from 'redux-saga/effects';
import {
  GlobalAction,
  GlobalActions,
  GlobalPut,
  ProduktRequested,
  ProdukttabelleEnum,
} from '@ps20-frontend/shop-integration-redux';
import { App, VersicherterBereichEnum } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { RsAction, RsActions } from '../rsActions';

export function* watchVersicherterBereichChanged() {
  yield takeLatest(
    RsActions.VERSICHERTER_BEREICH_CHANGED,
    safeSaga(loadProductAndTarifiere, App.RS),
  );
}

export function* loadProductAndTarifiere(action: RsAction<VersicherterBereichEnum>) {
  const globalPut = GlobalPut.getInstance();
  yield put(new RsActions().productLoadingInProgress(true));
  yield call(globalPut.put, productloadingActions(action.payload));
  yield take(GlobalActions.PRODUKT_RECEIVED);
  yield put(new RsActions().tarifChecked(indexForVersicherBereich(action.payload)));
  yield put(new RsActions().productLoadingInProgress(false));
}

function indexForVersicherBereich(versicherterBereich: VersicherterBereichEnum): number {
  return {
    [VersicherterBereichEnum.VERKEHR]: 0,
    [VersicherterBereichEnum.KOMBI]: 2,
  }[versicherterBereich];
}

function productloadingActions(
  versicherterBereich: VersicherterBereichEnum,
): GlobalAction<ProduktRequested> {
  return {
    [VersicherterBereichEnum.VERKEHR]: new GlobalActions().produktRequested({
      appId: App.RS,
      produkttabelle: ProdukttabelleEnum.RS_VERKEHR,
    }),
    [VersicherterBereichEnum.KOMBI]: new GlobalActions().produktRequested({
      appId: App.RS,
    }),
  }[versicherterBereich];
}
